const changeSizeByColor = () => {
	const colorBtns = document.querySelectorAll('.js-colorSelect-btn');
	if (colorBtns.length === 0) {
		return false;
	}

	const init = () => {
		const sizeElms = document.querySelectorAll('[data-colorselcect-id]:first-of-type');
		sizeElms.forEach((el) => {
			el.classList.add('show');
		});

		_selectDefaultSize();
	};

	const _changeSizes = (targetEl) => {
		const sibilings = targetEl.parentNode.querySelectorAll('[data-colorselcect-id]');
		sibilings.forEach((el, i) => {
			el.classList.remove('show');
		});
		targetEl.classList.add('show');
	};

	const _listener = function () {
		const targetId = this.getAttribute('data-colorselcect-target');
		const targetEl = document.querySelector('[data-colorselcect-id="' + targetId + '"]');
		if (targetEl) {
			_changeSizes(targetEl);
		}
		_selectDefaultSize();
	};

	const _selectDefaultSize = () => {
		$('.size-select-inner.show').each(function () {
			if ($(this).find('input[type="radio"]:checked').length === 0) {
				$(this).children('label:not(.soldout)').find('input[data-is-default="true"]').prop('checked', true);
			}
		});
	}

	init();

	colorBtns.forEach((el, i) => {
		el.addEventListener('click', _listener.bind(el), false);
	});
};

changeSizeByColor();
